import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { createTheming, JssProvider, createUseStyles as createUseStylesJSS } from 'react-jss';
import jss from './jss';
import defaultTheme from './defaultTheme';

// Theming namespaced
var ThemeContext = /*#__PURE__*/React.createContext({});
var theming = createTheming(ThemeContext);
var ThemeProvider = theming.ThemeProvider;
var CLASS_NAME_PREFIX = 'HoiPoi__';
var providerCounter = 0;
var customCreateGenerateId = function customCreateGenerateId() {
  var counter = 0;
  return function (rule, sheet) {
    var className = sheet.options.classNamePrefix;
    className = className.replace('-', '');
    className = "".concat(className, "__").concat(rule.key, "-").concat(providerCounter, "-").concat(counter++);
    className = className.replace('____', '__');
    return className;
  };
};
export default /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? defaultTheme : _ref$theme,
    _ref$jssProvider = _ref.jssProvider,
    jssProvider = _ref$jssProvider === void 0 ? {} : _ref$jssProvider;
  var generateId = customCreateGenerateId();
  providerCounter++;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(JssProvider, _extends({
    jss: jss,
    generateId: generateId,
    classNamePrefix: CLASS_NAME_PREFIX
  }, jssProvider), children));
});
export var createUseStyles = function createUseStyles(styles) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return createUseStylesJSS(styles, {
    theming: theming,
    name: name
  });
};
export var useTheme = theming.useTheme;